import React, { useEffect, useState, useRef, useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
  useTheme,
  Fab,
  IconButton,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useLocation, history } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from '@material-ui/icons/Add';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ModalML from '@/components/ModalML/NewModalML';
import EMPModal from './components/emp_modal/EMPModal';
import { OPT_DETAIL } from '@/constants';
import { TextFieldCom } from '@/components/FormType';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import TitleML from './components/TitleML';
import request from '@/utils/request';
import Styled from './indexStyles';

export default () => {
  const theme = useTheme();
  const location = useLocation();
  const { query } = location;
  const { id, opt, depName } = query;
  const saveRef = useRef();
  const { handleSubmit, control, setValue, getValues, errors } = useForm({
    defaultValues: {},
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [openDialog, setOpenDialog] = useState();
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeListSave, setEmployeeListSave] = useState([]);
  const [dialogStatus, setDialogStatus] = useState(false);
  const [currentAction, setCurrentAction] = useState({});
  const [copyList, setCopyList] = useState([]);
  const [pageData, setPageData] = useState({
    pageNum: 1,
    pageSize: 100,
    total: 0,
  });

  const employeeListSaveSort = useMemo(() => {
    //过滤出已经添加过的人员
    const filterHasList = employeeListSave.filter((i) =>
      copyList.find((j) => j.id === i.id),
    );
    //过滤出没有添加过的人员
    let filterNoList = employeeListSave.filter(
      (i) => !copyList.find((j) => j.id === i.id),
    );
    console.log('filterNoList', filterNoList);
    console.log('filterHasList', filterHasList);
    console.log('copyList', copyList);
    filterNoList.sort((a, b) => {
      return b.SORTTIME - a.SORTTIME;
    });
    return [...filterNoList, ...filterHasList];
  }, [employeeListSave]);

  const handleSubmitSuccess = (data) => {
    console.log(data);
    const params = {
      depName: data.depName,
      empIds: employeeListSaveSort.map((item) => item.id),
      id,
    };
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    const path = id ? '/coupon/dep/update' : '/coupon/dep/add';
    request(path, {
      method: 'POST',
      data: params,
    })
      .then((res) => {
        if (res?.code === 0) {
          window.message.toast({
            type: 'success',
            message: id ? '更新成功' : '新建成功',
            title: '成功',
          });
          setTimeout(() => {
            history.goBack();
          }, 2000);
        }
      })
      .catch(() => {
        setIsSubmit(false);
      });
  };
  const handleSubmitFail = () => {
    setIsSubmit(false);
  };

  const loadPage = async (params) => {
    if (id) {
      const detail = await request('/coupon/dep/detail/query/page', {
        method: 'POST',
        data: {
          depId: id,
          ...(params || pageData),
        },
      });
      setEmployeeListSave(detail.data || []);
      setEmployeeList(detail.data || []);
      setCopyList(detail.data || []);
      setValue('depName', depName);
      setPageData((val) => ({ ...val, total: detail.total }));
    }
  };

  useEffect(() => {
    loadPage();
  }, [id]);

  //关于退出
  const handleExitClick = () => {
    if (opt !== OPT_DETAIL) {
      setOpenDialog(true);
    } else {
      history.goBack();
    }
  };

  const columns = [
    {
      title: '员工姓名',
      id: 'empName',
      key: 'empName',
    },
    {
      title: '手机号',
      id: 'phone',
      key: 'phone',
    },
    {
      title: '状态',
      id: 'status',
      key: 'status',
      render: (_, record) => {
        return record.status === 'ENABLE' ? '可用' : '冻结';
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <IconButton aria-label="delete">
          <SvgIconML
            name="circleDelete"
            size={22}
            fill={
              opt === OPT_DETAIL
                ? theme.palette.secondary.disabled
                : theme.palette.primary.main
            }
            className="preview"
            disabled={opt === OPT_DETAIL}
            onClick={() => {
              opt !== OPT_DETAIL &&
                setCurrentAction({
                  open: true,
                  confirm: () => {
                    handleDeleteEmployee(record.id);
                  },
                });
            }}
          />
        </IconButton>
      ),
    },
  ];

  const handleDeleteEmployee = (tId) => {
    const newEmployeeList = employeeList.filter((item) => item.id !== tId);
    setEmployeeList(newEmployeeList);
    setEmployeeListSave(newEmployeeList);
    setCurrentAction({
      open: false,
    });
  };
  const handleClickAdd = () => {
    setDialogStatus(true);
    setEmployeeListSave(employeeListSave);
    setEmployeeList(employeeListSave);
  };

  const handleAddTicket = (selectList) => {
    console.log(selectList);
    setDialogStatus(false);
    setEmployeeList(selectList);
    setEmployeeListSave(selectList);
  };

  const handleCancel = () => {
    setDialogStatus(false);
  };

  const handleCloseDeleteDialog = () => {
    setCurrentAction({
      open: false,
    });
  };

  //换页
  const changePage = (obj) => {
    const pageParams = { ...pageData, ...obj };
    setPageData(pageParams);
    loadPage(pageParams);
  };

  return (
    <Styled theme={theme}>
      <Box>
        <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
          <Box
            borderRadius="12px"
            bgcolor="background.paper"
            p={[3, 4]}
            display="flex"
            flexDirection="column"
            gap="0 24px"
          >
            <TitleML title="部门信息" fontSize="19px" />
            <Box className="coupons-setting-box-4fr">
              <TextFieldCom
                control={control}
                label="部门名称"
                name="depName"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                rules={{ required: true, maxLength: 20 }}
                disabled={opt === OPT_DETAIL}
              />
            </Box>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '16px',
                marginTop: '40px',
              }}
            >
              <TitleML title="部门员工" fontSize="19px" />
              <Fab
                variant="extended"
                size="small"
                color="primary"
                aria-label="add"
                className="export"
                sx={{ marginRight: '16px' }}
                onClick={handleClickAdd}
                disabled={opt === OPT_DETAIL}
              >
                <AddIcon sx={{ width: '24px', height: '24px' }} />
                添加
              </Fab>
            </div>
            {/* <Table
              columns={columns}
              dataSource={employeeListSaveSort}
              size="small"
            /> */}
            <DataTableNativeML
              columns={columns}
              changePage={changePage}
              page={pageData}
              data={employeeListSaveSort}
              total={pageData.total}
              paging={true}
              columnKey="id"
            ></DataTableNativeML>
          </Box>
          <Box
            display="flex"
            gap="0 16px"
            borderRadius="12px"
            bgcolor="background.paper"
            p={[3, 4]}
            mt={1.5}
          >
            {opt !== OPT_DETAIL && (
              <Button
                ref={saveRef}
                variant="contained"
                className="coupons-setting-button"
                type="submit"
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
              >
                完成
              </Button>
            )}
            <Button
              variant="contained"
              className="coupons-setting-button"
              color="secondary"
              onClick={handleExitClick}
              startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
            >
              退出
            </Button>
          </Box>
        </form>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {opt !== OPT_DETAIL ? '退出后将不保存设置内容，确定要退出吗？' : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>

      <ModalML
        open={dialogStatus}
        setOpen={setDialogStatus}
        onCancel={handleCancel}
        title="选择优惠券"
        onConfirm={handleAddTicket}
        onClose={handleCancel}
      >
        <EMPModal
          open={dialogStatus}
          control={control}
          setOpen={setDialogStatus}
          onConfirm={handleAddTicket}
          chooseList={employeeList}
          setChooseList={setEmployeeList}
        ></EMPModal>
      </ModalML>
      <DialogDataML
        open={currentAction.open}
        title="移除员工"
        content="确定要移除该员工吗？"
        handleClose={handleCloseDeleteDialog}
        handleConfirm={currentAction.confirm}
      ></DialogDataML>
    </Styled>
  );
};
